// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e5bdc0b","455":"bea9caf4","640":"5a6ea84e","977":"ca962af7"}[chunkId] + ".chunk.js";
};